import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { StepperMainTool } from 'modules/main/domain/utils/stepper-tool';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { organizerIsTeamCreatingSelector } from 'modules/organizer/store/organizer/selectors';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { createTeam } from 'modules/teams/store/teams';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { trackEvent } from 'shared/analytics';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';
import { AppDispatch } from 'store/store';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'modules/app-shell/ui/layout/context';
import TeamForm, { SubmitTeamForm } from '../components/team-form/team-form';

const TeamsCreatePage = () => {
  const { t } = useLingui();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { setHeaderContent } = useMainLayout();
  const toastApiError = useToastApiError();

  const { info } = useOrganizer();
  const isCreating = useSelector(organizerIsTeamCreatingSelector);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback<SubmitTeamForm>(
    ({ values }) => {
      if (!info?.id) {
        toast.error(t`Турнир не найден. Попробуйте перезагрузить страницу.`);
        return Promise.resolve(false);
      }

      const logo = values.logo?.[0] && values.logo[0] instanceof File ? (values.logo[0] as File) : undefined;

      setIsLoading(true);
      return (
        dispatch(
          createTeam({
            tournamentId: info.id,
            name: values.name,
            shortName: values?.shortName ?? '',
            logo,
          }),
        )
          .unwrap()
          .then(({ team, logoError }) => {
            StepperMainTool.setByPath('stepper:main:createTeam', true);
            trackEvent('Team Created', { team_id: team.id, has_logo: logo !== undefined && !logoError });
            // Команда уже создана — уводим в её карточку и там же говорим про логотип: на форме
            // создания повторное «Сохранить» завело бы дубль.
            if (logoError) toastApiError(logoError, msg`Команда создана, но логотип не загрузился. Загрузите его в карточке команды`);
            navigate(Pages.TEAMS.builders.edit(team.id));
            return true;
          })
          // Команда не создана — остаёмся на форме с введёнными данными.
          .catch((error) => {
            toastApiError(error, msg`Не удалось создать команду`);
            return false;
          })
          .finally(() => setIsLoading(false))
      );
    },
    [dispatch, info?.id, navigate, t, toastApiError],
  );

  useEffect(() => {
    setHeaderContent(
      <UDHeaderTitle>
        <Trans>Добавление команды</Trans>
      </UDHeaderTitle>,
    );
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <>
      <div className="h-full w-full px-6 pt-6">
        {info && (
          <div className="h-full">
            {/* <CreateTeamForm tournamentId={info.id} /> */}
            <TeamForm onSubmit={onSubmit} isLoading={isLoading || isCreating} />
          </div>
        )}
      </div>
    </>
  );
};

export default TeamsCreatePage;
